import clsx from 'clsx';
import React from 'react';

import styles from './Card.module.scss';

export type SizeType = 'small' | 'medium' | 'large';

export interface CardProps {
  /** Body content of the card. */
  children?: React.ReactNode;
  /** Padding preset that controls the inner spacing. Defaults to `'medium'`. */
  size?: SizeType;
  /** Extra class forwarded to the root `<div>`. */
  className?: string;
}

/**
 * Surface container with the design-system rounded corners,
 * background, and padding presets. Use to group related content into
 * a single visual block. Any extra HTML attributes spread onto the
 * root `<div>`.
 */
export const Card = ({
  children,
  size = 'medium',
  className,
  ...rest
}: CardProps) => {
  return (
    <div
      data-testid="card"
      className={clsx(styles.root, styles[size], className)}
      {...rest}
    >
      {children}
    </div>
  );
};
